import { EuiFlexGroup, EuiText } from '@elastic/eui'
import { EuiSpacer, EuiButtonIcon } from '@elastic/eui'
import { EuiTitle } from '@elastic/eui'

interface SummarySectionProps {
  title: string
  content: string | React.ReactNode
  inEditMode?: boolean
  onEditClick?: () => void
}

export const SummarySection = ({ title, content, inEditMode, onEditClick }: SummarySectionProps) => (
  <div>
    <EuiFlexGroup direction='row' justifyContent='spaceBetween' alignItems='center'>
      <EuiTitle size={'xs'}>
        <p>{title}</p>
      </EuiTitle>
      {inEditMode && <EuiButtonIcon display='base' iconType='pencil' onClick={onEditClick} />}
    </EuiFlexGroup>
    <EuiSpacer size={'m'} />
    <EuiText style={{ whiteSpace: 'pre-wrap' }}>{content}</EuiText>
    <EuiSpacer size={'xl'} />
  </div>
)
